import { Component, Inject, Input } from '@angular/core';
import { Store } from '@src/store';
import * as _ from "lodash";
import { TranformtionImpactServerClientFilterObjectService } from '@src/services';

@Component({
    selector: 'impact-analysis-scopes',
    template: require('./impact-analysis-scopes.html'),
    styles: [require('./impact-analysis-scopes.scss')]
})
export class ImpactAnalysisScopesComponent {
    @Input() public index: any;
    public envNameSource:string
    public envNameTarget:string
    public processData:any;
    public targetCompareType : string
    public buildType:string;
    public scopeLength:number
    public sourceCompareType:string
    public numberOfSetsArr;

    constructor(private store: Store, @Inject('$stateParams') private $stateParams: any, @Inject('$filter') private $filter: any ,private tranformtionImpactServerClientFilterObjectService : TranformtionImpactServerClientFilterObjectService) {
        this.processData = this.tranformtionImpactServerClientFilterObjectService.getNewjsonData(this.store.getState().project.impact_analysis, this.store.getState().enums,this.$stateParams.jobEnv,this.$filter('changeEnumJobNameToName'));
        if(this.processData){
            this.buildType = this.processData.build_type ? this.processData.build_type : ""
            this.envNameSource =  this.processData.scopes[0].SourceSchema.envName ? this.processData.scopes[0].SourceSchema.envName : ""
            this.envNameTarget =  this.processData.scopes[0].SourceSchema.envName ? this.processData.scopes[0].TargetSchema.envName : ""
            this.scopeLength = this.processData.scopes.length && this.processData.scopes ? this.processData.scopes.length : 0
            this.sourceCompareType = this.processData.sourceCompareType ? this.processData.sourceCompareType : ""
            this.targetCompareType = this.processData.targetCompareType  ? this.processData.targetCompareType : ""
            this.numberOfSetsArr = _.map(this.processData.scopes, (item) => {
                item.SourceSchema.type_strip = 'Source';
                item.TargetSchema.type_strip = "Target";
                return { source: item.SourceSchema, target: item.TargetSchema };
        })
     }

 }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-scopes-ang7/impact-analysis-scopes.ts